/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, array, string, number, func, bool, any, shape,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';
import Grid from '@material-ui/core/Grid';
import Cookies from 'universal-cookie';
import ReactHtmlParser from 'react-html-parser';
import { connect, useSelector } from 'react-redux';
import { compose } from 'recompose';
import TermsModal from '../Partials/BottomMenuModal';
import SocialLinks from '../Partials/SocialLinksBlock';
import GraphqlSeoFooter from '../../GraphqlHomePage/Partials/GraphqlSeoFooter/GraphqlSeoFooter';
import GraphqlSeoFooterV2 from '../../GraphqlHomePage/Partials/GraphqlSeoFooter/GraphqlSeoFooterV2';
import extractMenuAttributes from '../../../../helpers/contentstack/extractMenuAttributes';
import { actions as tagManagerActions } from '../../../../../state/ducks/TagManager';
import customBreakpoints from '../../../../helpers/customBreakpoints';
import { getPageInformation } from '../../../../../state/ducks/App/App-Selectors';
import { determineLanguagePrefixPath } from '../../../../helpers/determineInternationalizationPath';
import Subscription from '../Subscription/Subscription';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const cookies = new Cookies();

const styles = (theme) => {
    const { breakpoints } = theme;

    return ({
        copyRight: {
            fontSize: '14px',
            textAlign: 'center',
            width: '100%',
            margin: 'auto',
            maxWidth: '1440px',
            background: theme.palette.desktopBgCopyright,
            '&> div': {
                maxWidth: '1400px',
                margin: 'auto',
                padding: '50px 0',
                [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                    paddingTop: 0,
                },
                '&> div': {
                    '&> span': {
                        '&:first-child': {
                            paddingLeft: '5px',
                        },
                        '& a': {
                            textDecoration: 'underline',
                            color: theme.palette.black,
                            '& span': {
                                padding: 0,
                                whiteSpace: 'nowrap',
                            },
                        },
                        '&:last-child': {
                            '&> span': {
                                display: 'none',
                            },
                        },
                    },
                },
            },
        },
        plaCopyRight: {
            fontSize: '0.8125rem',
            textAlign: 'center',
            width: '100%',
            margin: 'auto',
            maxWidth: '1440px',
            background: theme.palette.desktopBgCopyright,
            '&> div': {
                maxWidth: '1400px',
                margin: 'auto',
                padding: '10px',
                [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                    paddingTop: 0,
                },
                '&> div': {
                    '&> span': {
                        '&:first-child': {
                            paddingLeft: '5px',
                        },
                        '& a': {
                            textDecoration: 'underline',
                            color: theme.palette.black,
                            '& span': {
                                padding: 0,
                                whiteSpace: 'nowrap',
                            },
                        },
                        '&:last-child': {
                            '&> span': {
                                display: 'none',
                            },
                        },
                    },
                },
            },
        },
        plaGridDiv: {
            paddingRight: '15px',
            paddingLeft: '15px',
        },
        gridDiv: {
            maxWidth: '1440px',
            margin: 'auto',
            width: '100%',
            '& .pla-container': {
                maxWidth: 1270,
                margin: '0 auto',
                paddingTop: 40,
                '&>div': {
                    '&:nth-child(5)': {
                        maxWidth: '25%!important',
                        flexBasis: '25%!important',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0px 20px',
                        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                            maxWidth: '100%!important',
                            flexBasis: '100%!important',
                            padding: 0,
                        },
                    },
                    '&:nth-child(4)': {
                        maxWidth: '27%!important',
                        flexBasis: '27%!important',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 20px',
                        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                            maxWidth: '100%!important',
                            flexBasis: '100%!important',
                            padding: 0,
                        },
                    },
                },
                [theme.breakpoints.down(breakpoints?.maxWidth?.screen_ipad_11)]: {
                    maxWidth: 720,
                },
                [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                    '&>div': {
                        maxWidth: '100%!important',
                        flexBasis: '100%!important',
                        padding: 0,
                        '&:nth-child(4)': {
                            order: 4,
                        },
                    },
                    '& .socialTitle': {
                        display: 'none',
                    },
                },
            },
        },
        plantsMenu: {
            lineHeight: '18px!important',
            marginBottom: '10px',
            color: `${theme.palette.black} !important`,
        },
        subMenu: {
            display: 'block',
            padding: '0',
            fontSize: '14px',
            lineHeight: '40px',
            fontWeight: '600',
            textDecoration: 'none',
            color: theme.palette.footerLinks,
            textRendering: 'optimizeLegibility',
            textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
            textAlign: theme.palette.footer?.textAlign || 'left',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                textAlign: 'center',
                fontSize: '12px',
                lineHeight: '36px',
            },
        },
        description: {
            padding: '0',
            fontSize: '14px',
            lineHeight: '40px',
            color: theme.palette.footer?.description,
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '12px',
                lineHeight: '22px',
            },
        },
        menuTitle: {
            fontFamily: 'BebasxNeue, sans-serif',
            fontSize: '27px',
            lineHeight: '42px',
            padding: '0',
            display: 'block',
            fontWeight: '600',
            color: theme.palette.common?.black,
            textAlign: theme.palette.footer?.textAlign || 'left',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                textAlign: 'center',
                paddingBottom: '5px',
            },
            '&.socialTitle': {
                display: 'inline-block',
            },
        },
        innerGrid: {
            marginBottom: '10px',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                paddingLeft: '10px',
                paddingRight: '10px',
                textAlign: 'center',
                '&.plaSubscription-form': {
                    width: '215px !important',
                },
            },
            [theme.breakpoints.down(breakpoints?.maxWidth?.screen_ipad_11)]: {
                '& a': {
                    textAlign: 'center',
                },
            },
            '&:not(:first-child)': {
                '&> div': {
                    paddingTop: '50px',
                },
            },
            '&.noBottomMargin': {
                marginBottom: '0px',
            },
        },
        subMenuBottom: {
            padding: '7px',
            cursor: 'pointer',
            color: theme.palette.tpColor,
        },
        legalTag: {
            cursor: 'pointer',
            color: theme.palette.tpColor,
        },
        desktopColumn: {
            flexGrow: 0,
            maxWidth: '20%',
            flexBasis: '20%',
            padding: '40px 20px',
            '&:first-child': {
                maxWidth: '40%',
                flexBasis: '40%',
            },
            '&:not(:first-child)': {
                '&> div': {
                    width: '100%',
                    paddingTop: theme?.palette?.footer?.paddingTop || '0',
                    [theme.breakpoints.up(customBreakpoints.tabPortrait)]: {
                        paddingTop: theme?.palette?.footer?.paddingTop || '0',
                    },
                    [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                        paddingTop: '0',
                    },
                },
            },
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                maxWidth: '100% !important',
                flexBasis: '100% !important',
                padding: '0 20px',
            },
        },
        desktopPlaColumn: {
            padding: '0px 20px 40px 20px',
        },
        plaColumn: {
            maxWidth: '19%!important',
            flexBasis: '19%!important',
            paddingBottom: '0px',
            paddingLeft: '20px',
            paddingRight: '15px',
            '&:first-child': {
                maxWidth: '10%!important',
                flexBasis: '10%!important',
                paddingLeft: '0',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
            },
            // '&:nth-child(3)': {
            //     display: 'none',
            // },
        },
        socialBlock: {
            display: 'inline-block',
            verticalAlign: 'middle',
        },
        socialPlantsBlock: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-around',
            flex: '0 0 50%',
            '& a': {
                '&:first-child': {
                    paddingLeft: 10,
                },
            },
            '& img': {
                padding: '0px!important',
                marginRight: 0,
            },
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                margin: 'auto',
            },
            [theme.breakpoints.down(breakpoints?.maxWidth?.screen_ipad_11)]: {
                flex: '0 0 40%',
            },
        },
        socialImage: {
            width: '100%',
        },
        socialLink: {
            '& img': {
                height: '24px',
                width: 'auto',
                marginRight: '5px',
                padding: '2px',
            },
        },
        canadaLogo: {
            '& img': {
                maxWidth: '200px',
                height: '45px',
            },
        },
        plantsLogo: {
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                paddingTop: '2.5rem',
            },
        },
        canadaFooterMenu: {
            '&:first-child': {
                marginTop: '30px',
            },
        },
        socialColumn: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
        },
        plaSocialHeader: {
            fontFamily: theme.typography.secondaryFontFamily,
            fontSize: '2.8125rem',
            lineHeight: '1.5em',
            fontWeight: 400,
        },
        plaBorder: {
            borderLeft: `1px solid ${theme.palette.black}`,
            borderRight: `1px solid ${theme.palette.black}`,
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                border: 'none',
            },
        },
        irmlink: {
            display: 'inline !important',
            '& a': {
                textDecoration: 'underline !important',
                '&:before': {
                    content: '" | "',
                    color: 'black',
                    textDecoration: 'unset !important',
                    display: 'inline-block',
                    marginLeft: '3px',
                    marginRight: '3px',
                },
            },
        },
        teconsent: {
            display: 'inline !important',
            '& a': {
                textDecoration: 'underline !important',
            },
        },
    });
};

const triggerClick = (self, setPopupTitle, title) => {
    setPopupTitle({ title, self });
};
const footerLink = (item, classes, styleOverrides, trackEvent, brand) => {
    const { link: { href, title } } = item;
    const plantsMenuLink = brand?.code === 'PLA' ? classes.plantsMenu : null;
    const seed = useUIDSeed();
    const handleDoNotSellMyInformationClick = () => {
        const current = new Date();
        const next2Years = new Date();
        next2Years.setFullYear(current.getFullYear() + 2); // 2 years

        cookies.set('DoNotSell', 'Yes', {
            expires: next2Years,
        });
    };

    const footerLinkClickHandler = (footerLinkItem) => {
        if (trackEvent) {
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: footerLinkItem?.tracking_event_category || 'Global Footer',
                eventAction: footerLinkItem?.tracking_event_action || 'Click' || '',
                eventLabel: footerLinkItem?.tracking_event_label || title || '',
            });
        }
        if (footerLinkItem.link?.title === 'Do Not Sell My Personal Information') {
            return handleDoNotSellMyInformationClick();
        }

        return undefined;
    };

    return (
        href.indexOf('http://') === 0 || href.indexOf('https://') === 0 || href.indexOf('tel:') === 0
            ? (
                <a
                    key={`${href}`}
                    href={href}
                    className={`${classes.subMenu} ${plantsMenuLink}`}
                    onClick={() => footerLinkClickHandler(item)}
                >
                    {ReactHtmlParser(title)}
                </a>
            )
            : (
                <Link
                    key={seed(item)}
                    to={determineLanguagePrefixPath(href)}
                    className={`${classes.subMenu} ${plantsMenuLink}`}
                    onClick={() => footerLinkClickHandler(item)}
                >
                    {ReactHtmlParser(title)}
                </Link>
            )
    );
};

const socialLogo = (classes, title, data, brand) => (
    <>
        <span className={`${classes.menuTitle} ${brand?.code === 'PLA' ? classes.plaSocialHeader : null} ${classes.socialTitle} socialTitle`}>
            {title}
        </span>
        {data
         && (
             <div className={`${classes.socialBlock} ${brand?.code === 'PLA' ? classes.socialPlantsBlock : null}`}>
                 {data.map((item) => {
                     if (item?.link?.title && item?.icon?.url && item?.link?.href) {
                         return (
                             <a key={`${item.link.title}`} className={classes.socialLink} href={item.link.href} title={item.link.title}>
                                 <img className={classes.socialImage} src={item.icon.url} alt={item.link.title} />
                             </a>
                         );
                     } return null;
                 })}
             </div>
         )}
    </>
);

const renderLogo = (item, brand, classes, menuBlocks, attributes, trackEvent) => (
    item?.tracking_event_category?.includes('Logo')
        ? (
            <div className={`${brand?.code === 'PLA' ? classes.plantsLogo : classes.canadaLogo}`}>
                {brand?.code === 'PLA' ? (
                    <Link to="/">
                        <img src={item.icon.url} alt={item.tracking_event_category} />
                        <p className={classes.description}>{item.link.title}</p>
                    </Link>
                ) : (
                    <>
                        <img src={item.icon.url} alt={item.tracking_event_category} />
                        <p className={classes.description}>{item.link.title}</p>
                    </>
                )}
            </div>
        ) : (
            <div className={menuBlocks?.[0]?.menu_groups.menu_item?.[0]?.tracking_event_category === 'Canada Logo' ? classes.canadaFooterMenu : classes.footerMenu}>
                {footerLink(item, classes, attributes, trackEvent, brand)}
            </div>
        )
);

/* eslint no-nested-ternary: "off" */
const mainMenu = (classes, x, menuBlocks, attributes, trackEvent, seed, brand) => (
    <div key={seed(x)} className={x.title === 'FOLLOW US' ? classes.socialColumn : ''}>
        {x.title === 'FOLLOW US'
            ? socialLogo(classes, x.title, x.menu_item, brand)
            : x.title === 'Subscription' ? <Subscription />
                : (
                    <>
                        {x.title && (
                            <span className={classes.menuTitle}>
                                {x.title}
                            </span>
                        )}
                        {x.menu_item.map((item) => (
                            item.tracking_event_category === '0800flowers logo'
                                ? (
                                    <>
                                        <img src={item.icon.url} alt="0800flowers logo" />
                                        <p className={classes.description}>{item.link.title}</p>
                                    </>
                                )
                                : (renderLogo(item, brand, classes, menuBlocks, attributes, trackEvent))
                        ))}
                    </>
                )}
    </div>
);

const MenuColumn = ({
    columnNumber, classes, menuBlocks, attributes, widthStyle, trackEvent, widthStyleDescription, brand,
}) => {
    const seed = useUIDSeed();
    const plaConditon = brand?.code === 'PLA' && columnNumber < 4;
    const plaBorder = brand?.code === 'PLA' && columnNumber === 4;
    const isCanada = brand?.code === 'CAN';
    const isPlants = brand?.code === 'PLA';
    return (
        <Grid item className={`${classes.desktopColumn} ${isPlants ? classes.desktopPlaColumn : null } ${plaBorder ? classes.plaBorder : null} ${plaConditon ? classes.plaColumn : null}`} style={columnNumber !== 1 ? widthStyle : widthStyleDescription}>
            <div className={`${classes.innerGrid} ${isCanada && 'noBottomMargin'}`}>
                {menuBlocks
                    .map((a) => a.menu_groups)
                    .filter((b) => b?.column === columnNumber)
                    .map((x) => mainMenu(classes, x, menuBlocks, attributes, trackEvent, seed, brand))}
            </div>
        </Grid>
    );
};

MenuColumn.propTypes = {
    columnNumber: number.isRequired,
    classes: object.isRequired,
    menuBlocks: array.isRequired,
    attributes: object.isRequired,
    widthStyle: object.isRequired,
    widthStyleDescription: object.isRequired,
    trackEvent: func.isRequired,
    brand: shape({
        domain: string.isRequired,
    }).isRequired,
};

// Check this function for <a> or <Link>
const footerBottomLink = (classes, item, brandCode) => {
    if (!item) {
        return null;
    }
    const href = item.link?.href || '';
    const title = item.link?.title || '';
    if (brandCode === 'PLA' && title.toLowerCase().includes('cookie')) {
        return (<><div id="teconsent" className={classes.teconsent} /> | </>);
    }
    if (brandCode === 'CAN' && title.toLowerCase().includes('cookie')) {
        return (<><div id="teconsent" className={classes.teconsent} /> | </>);
    }
    if (title.toLowerCase().includes('information')) {
        return <div id="irmlink" className={classes.irmlink} />;
    }
    let showCharacter = true;
    if (brandCode === 'PLA' && title.indexOf('Site') > -1) showCharacter = false;
    if (brandCode === 'CAN' && title.toLowerCase().includes('cookie')) showCharacter = false;
    return (
        href.indexOf('http://') === 0 || href.indexOf('https://') === 0 || title === 'Site Map'
            ? (
                <>
                    <a key={`${href}${title}`} href={href} target="_blank" rel="noreferrer" className={classes.legalTag}>
                        {title}
                    </a>
                    <span> | </span>
                </>
            )
            : (
                <span className={classes.linkWrapper}>
                    <Link
                        key={`${href}${title}`}
                        className={classes.productLink}
                        to={determineLanguagePrefixPath(href)}
                    >
                        <span className={classes.subMenuBottom}>
                            {title}
                        </span>
                    </Link>
                    { showCharacter && <span> | </span> }
                </span>
            )
    );
};
const DesktopFooterBlock = ({
    block, classes, popUpData, self, setDialog, title, openDialog, setPopupTitle, trackEvent, presentationFamily, pageInfo, brand,
}) => {
    const featureFlags = useSelector(getFeatureFlags);
    const seoFooterVersion = featureFlags?.['which-seo-footer-version-enabled'];
    const blockKey = Object.keys(block)[0];
    const blockObj = block[blockKey];
    switch (blockKey) {
        case 'menu_group_links': {
            const menu = blockObj.menu_group_link_ref[0];
            const attributes = extractMenuAttributes(menu);
            let numberOfColumns = 1;
            menu.menu_blocks
                .map((a) => a.menu_groups)
                .forEach((b) => { numberOfColumns = (Math.max(b?.column || 2, numberOfColumns) + 1); });
            const totalColumns = numberOfColumns - 1;
            let widthPercent = '';
            if (presentationFamily === 'growthbrand') widthPercent = `${60.0 / (numberOfColumns - 2)}%`;
            if (brand?.code === 'PLA') widthPercent = `${100.0 / (numberOfColumns - 3)}%`;
            else widthPercent = `${100.0 / numberOfColumns}%`;
            const widthStyle = { maxWidth: widthPercent, flexBasis: widthPercent };
            const widthStyleDescription = { maxWidth: '40%', flexBasis: '40%' };
            const columns = [];
            for (let n = 1; n <= totalColumns; n += 1) {
                columns.push(<MenuColumn trackEvent={trackEvent} columnNumber={n} key={n} classes={classes} menuBlocks={menu.menu_blocks} attributes={attributes} widthStyle={widthStyle} widthStyleDescription={widthStyleDescription} brand={brand} />);
            }

            return (
                <div className={classes.gridDiv}>
                    <Grid container className={`${brand?.code === 'PLA' ? 'pla-container' : classes.parentGrid}`}>
                        {columns}
                    </Grid>
                    {/* TODO: test first then remove */}
                    {/* <TermsModal self={self} setDialog={setDialog} title={title} show={openDialog} data={popUpData} /> */}
                </div>
            );
        }
        case 'copyright':
            return (
                <>
                    <div className={brand?.code === 'PLA' ? classes.plaCopyRight : classes.copyRight} style={{ color: blockObj.color }}>
                        <Grid container>
                            <Grid item xs={12} className={brand?.code === 'PLA' ? classes.plaGridDiv : ''}>
                                {blockObj?.copy}
                                {popUpData?.map((item) => (item.popup ? (
                                    <span
                                        key={`${item.link.title}`}
                                        onClick={() => {
                                            triggerClick(self, setPopupTitle, item.popup_title);
                                        }}
                                        role="presentation"
                                        className={classes.subMenuBottom}
                                        title={item.link.title}
                                    >
                                        {item.link.title}
                                    </span>
                                )
                                    : (
                                        footerBottomLink(classes, item, brand?.code)
                                    )
                                ))}
                            </Grid>
                        </Grid>
                    </div>
                    <TermsModal self={self} setDialog={setDialog} title={title} show={openDialog} data={popUpData} />
                </>

            );
        case 'seo':
            if (pageInfo?.type === 'home') {
                return seoFooterVersion === 'v2' ? <GraphqlSeoFooterV2 data={blockObj} /> : <GraphqlSeoFooter data={blockObj} pageInfo={pageInfo} />;
            }
            return null;
        case 'social_links':
            return <SocialLinks data={blockObj} />;
        default:
            // console.warn('unhandled footer block', blockKey); // TODO: Convert to mbpLogger?
            return null;    // TODO: log warning for unhandled block
    }
};
DesktopFooterBlock.propTypes = {
    block: object.isRequired,
    classes: object.isRequired,
    popUpData: array,
    title: string,
    openDialog: bool,
    setDialog: func,
    setPopupTitle: func,
    self: any,
    trackEvent: func.isRequired,
    presentationFamily: string.isRequired,
    pageInfo: shape({
        type: string,
    }),
    brand: shape({
        domain: string.isRequired,
    }).isRequired,
};

DesktopFooterBlock.defaultProps = {
    popUpData: [],
    title: '',
    openDialog: false,
    setDialog: () => {},
    setPopupTitle: () => {},
    self: null,
    pageInfo: null,
};

const mapStateToProps = (state) => ({   // eslint-disable-line arrow-parens
    pageInfo: getPageInformation(state),
});

const mapDispatchToProps = {
    trackEvent: tagManagerActions.trackEvent,
};

const enhance = compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(DesktopFooterBlock);
